// extracted by mini-css-extract-plugin
export var questions = "FAQ-module--questions--27zmC";